import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ExistingAccountNotice = () => {
    const { t } = useTranslation();

    return (
        <Box sx={{ mb: 3 }}>
            <Alert severity="info">
                <Typography variant="body1" fontWeight="bold">
                    {t('Register.ExistingRecord')}
                </Typography>
                <Typography variant="body2">{t('Register.ClaimAccountText')}</Typography>
            </Alert>
        </Box>
    );
};

export default ExistingAccountNotice;
